import {
	getAttachmentsIds,
	phoneShapeToString,
	toStringDate,
} from '@gov-nx/utils/common';
import type { PPPZapisForm } from './formSteps/formSteps.types';
import type { DataRequestType } from './prepareSubmitData.types';
import { PPPTypeOptions } from './constants';

export const prepareSubmitData = (data: PPPZapisForm): DataRequestType => ({
	params: {},
	body: {
		kodPodani: 'PPP_ZAPIS',
		typSubjektu: 'FO',

		kontaktEmail: data._useEmail && data.email ? data.email : undefined,
		kontaktTelefon:
			data._usePhone && data.phone ? phoneShapeToString(data.phone) : undefined,

		typPppKod: data.PPPSelect,
		ovmKod: !data.isOVMDefunct
			? data.pppOvmAutocomplete?.selected?.kod
			: undefined,
		ovmJeZanikle:
			data.pppOvmAutocomplete?.selected?.zanikly || data.isOVMDefunct,
		ovmZanikleNazev: data.isOVMDefunct ? data.defunctOVMName : undefined,

		// adresa OVM
		ovmAdresaUlice: data.isOVMDefunct
			? data.defunctOVMStreet
			: data.pppOvmAutocomplete?.selected?.adresa?.ulice,
		ovmAdresaCisloPopisne: data.isOVMDefunct
			? data.defunctOVMDescriptiveNumber
			: data.pppOvmAutocomplete?.selected?.adresa?.cisloPopisne,
		ovmAdresaCisloOrientacni: data.isOVMDefunct
			? data.defunctOVMOrientationNumber
			: data.pppOvmAutocomplete?.selected?.adresa?.cisloOrijentacni,
		ovmAdresaCisloEvidencni: data.isOVMDefunct
			? data.defunctOVMEvidenceNumber
			: data.pppOvmAutocomplete?.selected?.adresa?.cisloEvidencni,
		ovmAdresaObec: data.isOVMDefunct
			? data.defunctOVMCity
			: data.pppOvmAutocomplete?.selected?.adresa?.obec,
		ovmAdresaCastObce: data.isOVMDefunct
			? data.defunctOVMCityPart
			: data.pppOvmAutocomplete?.selected?.adresa?.castObce,
		ovmAdresaPsc: data.isOVMDefunct
			? data.defunctOVMPostalCode
			: data.pppOvmAutocomplete?.selected?.adresa?.psc,

		// podnet k doplneni PPP seznamu
		podnetDoplneni: data.PPPSelect === PPPTypeOptions.PodnetKDoplneniSeznamu,
		podnetNazevPpp: data.missingPPP,
		podnetOvmKod: data.missingPPPOvm?.selected?.kod,
		podnetOduvodneni: data.reasonForAddingMissingPPP,

		// dokument
		dokumentCislo: data.number,
		datumVydani: data.issueDate ? toStringDate(data.issueDate) : undefined,
		datumPlatnostiOd: data.datumOd ? toStringDate(data.datumOd) : undefined,
		datumPlatnostiDo: data.datumDo ? toStringDate(data.datumDo) : undefined,
		souborPrilohy: data.fileUpload
			? getAttachmentsIds(data.fileUpload)
			: undefined,
	},
});
